<hs-lazy-load-panel [content]="lazyLoadPanelContent" [panelKey]="panelKey">
</hs-lazy-load-panel>

<ng-template #lazyLoadPanelContent>
  <hs-no-loaded-or-focused-account [content]="loadedAccountDependentContent">
  </hs-no-loaded-or-focused-account>
</ng-template>

<ng-template #loadedAccountDependentContent>
  <div class="jobs-grid-container" #jobsGrid>
    <hs-jobs-grid
      [selectedJobs]="selectedJobs"
      [selectedCommandsJobIds]="selectedCommandsJobIds"
      [focusedIds]="focusedIds$ | async"
      (selectJobIds)="selectedJobIds = $event"
      (resetSelectedJob)="onClearSelectedJob()"
      (jobIdSearchChanged)="setSelectedCommandsJobIds($event)"
    ></hs-jobs-grid>
  </div>
  <hs-resize-handle
    [elem1]="jobsGrid"
    [elem2]="jobsSubPanels"
    [initialResizeHandleState]="state?.resizeHandleState"
    (resizeFinished)="onResizeFinished($event)"
  ></hs-resize-handle>
  <div id="jobs-sub-panels" #jobsSubPanels>
    <ul ngbNav #nav="ngbNav" class="nav-tabs" [activeId]="activeTabIndex">
      <li [ngbNavItem]="1">
        <a class="jobs-nav-item" ngbNavLink>User Commands</a>
        <ng-template ngbNavContent>
          <hs-select-single-job-message
            [numberOfJobs]="selectedJobIds.length"
            *ngIf="selectedJobIds.length < 1 || selectedJobIds.length > 250"
          ></hs-select-single-job-message>
          <hs-commands
            [jobId]="selectedJobIds"
            (selectedCommandsJobIds)="setSelectedCommandsJobIds($event)"
            *ngIf="selectedJobIds.length >= 1"
          ></hs-commands>
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <a class="jobs-nav-item" ngbNavLink>System Commands</a>
        <ng-template ngbNavContent>
          <hs-select-single-job-message
            [numberOfJobs]="selectedJobIds.length"
            *ngIf="selectedJobIds.length < 1 || selectedJobIds.length > 250"
          ></hs-select-single-job-message>
          <hs-system-commands
            [jobId]="selectedJobIds"
            (selectedCommandsJobIds)="setSelectedCommandsJobIds($event)"
            *ngIf="selectedJobIds.length >= 1"
          ></hs-system-commands>
        </ng-template>
      </li>
      <li [ngbNavItem]="3">
        <a class="jobs-nav-item" ngbNavLink>Exception</a>
        <ng-template ngbNavContent>
          <hs-select-single-job-message
            [numberOfJobs]="selectedJobIds.length"
            *ngIf="selectedJobIds.length < 1 || selectedJobIds.length > 250"
          ></hs-select-single-job-message>
          <hs-exception
            [jobId]="selectedJobIds[0]"
            *ngIf="selectedJobIds.length === 1"
          ></hs-exception>
        </ng-template>
      </li>
      <li [ngbNavItem]="4">
        <a ngbNavLink>Status</a>
        <ng-template ngbNavContent>
          <hs-select-single-job-message
            [numberOfJobs]="selectedJobIds.length"
            *ngIf="selectedJobIds.length < 1 || selectedJobIds.length > 250"
          ></hs-select-single-job-message>
          <hs-status
            [jobId]="selectedJobIds[0]"
            *ngIf="selectedJobIds.length === 1"
          ></hs-status>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-3"></div>
  </div>
</ng-template>
